import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import CreateCOA from '../CreateForm/CreateCOA';
import UpdateCOA from '../UpdateForm/UpdateCOA';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import { DELETE_COA_EXPORT, GET_PRODUCTS_LIST, LIST_COAS_EXPORT, LIST_COMMERCIAL_INVOICES_EXPORT, LIST_IMPORT_SHIPPING_MARKS } from '../../../services/apiRoutes';
import { getCommanExportShipmentId, getPortMasters } from '../../../services/CommonServices';
import { genericPost } from '../../../services/authServices';
import COAView from '../ViewDetails/COAView';
import axios from 'axios';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


const COA = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();

    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('COA');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({ open: false, text: '', type: '' });
    const [selectedCOA, setSelectedCOA] = useState(null);
    const [viewModal, setViewModal] = useState(false);
    const [portMasters, setPortMasters] = useState([]);
    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);
    const [products, setProducts] = useState([]);
    const [newShippingId, setNewShippingId] = useState(null);
    const [invoiceList, setInvoiceList] = useState([]);
    const [shippingMarkList, setshippingMark] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')



    let customerId, cifFob;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;

            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            fetchDataCommercialInvoiceList();
            fetchProductsList();
            fetchDataShippingMark();
            getCommonData();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, selectedCOA, token, deleteAlert, modal]);

    const getCommonData = async () => {
        const getPortMastersData = await getPortMasters()
        setPortMasters(getPortMastersData)
    }


    const fetchDataShippingMark = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: customerId,
                commanShipmentId: getCommanExportShipmentId,
                shipmentId: shipmentId,

            };
            const response = await genericPost(LIST_IMPORT_SHIPPING_MARKS, payload, {
            });
            if (response.data.success && response.data.shippingmark) {
                const shippingMarkData = response.data.shippingmark.map((mark, index) => ({
                    id: mark.shippingMarkId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    companyId: mark.companyId || '',
                    title: mark.batchNo || '',
                    ProductId: mark.productsList.productName || '',
                    createdAt: mark.createdAt || '',
                    updatedAt: mark.updatedAt || '',
                }));
                setshippingMark(shippingMarkData);
            } else {
                setError('No shipping marks found');
            }
        } catch (error) {
            setError('Error fetching shipping marks');
            console.error('Error fetching shipping marks', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: customerId,
                shipmentId: shipmentId,
            };

            const response = await genericPost(LIST_COAS_EXPORT, payload);

            if (response.data.success) {
                const coaData = response.data.data.map((item, index) => {
                    const particulars = item.particulars.map((particular) => ({
                        coaParticularsId: particular.coaParticularsId || '',
                        items: particular.items || '',
                        standard: particular.standard || '',
                        result: particular.result || '',
                        levelId: particular.levelId || '',
                    }));

                    return {
                        coaId: item.coaId || '',
                        index: (index + 1).toString().padStart(2, '0'),
                        userId: item.userId || '',
                        companyId: item.companyId || '',
                        clientCompanyId: item.clientCompanyId || '',
                        toAddress: item.toAddress || '',
                        invoiceNo: item.invoiceNo || '',
                        date: companyDateFormat(item?.date) || '',
                        loadingPort: item.loadingPort || '',
                        destinationPort: item.destinationPort || '',
                        productName: item?.product?.productName || '',
                        conculation: item.conculation || '',
                        analyst: item.analyst || '',
                        examiner: item.examiner || '',
                        approved: item.approved || false,
                        casNo: item.casNo || '',
                        iupac: item.iupac || '',
                        createdAt: item.createdAt || '',
                        updatedAt: item.updatedAt || '',
                        particulars,
                        customerName: item.customer?.clientCompanyName || '',
                        customerCountry: item.customer?.mailingCountry?.name || '',
                        shipmentId: item.shipmentId || '',
                        batchNo: item.shippingMarks?.batchNo || '',

                    };
                });
                const { newShippingId } = response.data;
                setNewShippingId(newShippingId);
                setData(coaData);
            } else {
                setError('No COA data found');
            }
        } catch (error) {
            setError('Error fetching COA data');
            console.error('Error fetching COA data', error);
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (coaId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_COA_EXPORT(coaId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                fetchButtonList();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };
    const fetchDataCommercialInvoiceList = async () => {
        try {
            const payload = {
                customerNamesId: customerId,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES_EXPORT, payload, {
            });
            if (response.data && response.data.success && response.data.data) {
                const customersData = response.data.data.map((customer) => ({
                    id: customer.commercialInvoiceNo,
                    title: customer.commercialInvoiceNo,
                }));
                setInvoiceList(customersData);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };

    const fetchProductsList = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        const payload = {
            clientCompanyId: customerId,
        };

        try {
            const response = await axios.post(GET_PRODUCTS_LIST, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200 && response.data.success) {
                const productData = response.data.productsList;
                console.log(productData);
                setProducts(productData);
            } else {
                console.error('Failed to fetch products list:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products list:', error);
        }
    };

    const columns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'shipmentId', label: 'Shipping Id', accessor: 'shipmentId', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center',
            },
        },
        { id: 'productName', label: 'Product Name', accessor: 'productName' },
        {
            id: 'batchNo', label: 'Batch No.', accessor: 'batchNo', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.coaId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.coaId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.coaId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];



    const handleUpdateClick = (coa) => {
        setSelectedCOA(coa);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setSelectedCOA(null);
    };
    const handleViewClick = (id) => {
        setSelectedCOA(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setSelectedCOA('');
    };


    if (!shipmentDetails) {
        return <p>  <CustomLoader open={shipmentLoading} /> </p>;
    }

    const addressToClient = `${shipmentDetails.customer.billingStreet || ''}, ${shipmentDetails.customer.billingCity.name || ''}, ${shipmentDetails.customer.billingState.name || ''}, ${shipmentDetails.customer.billingCountry.name || ''}, ${shipmentDetails.customer.billingPincode || ''}.`.trim();
    const companyName = shipmentDetails.customer.clientCompanyName;
    const addressTo = `${companyName || ''}, ${addressToClient || ''}`.trim();

    const phoneNumber = shipmentDetails.customer.mobile;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const initial = shipmentDetails.customer.clientCompanyName ? shipmentDetails.customer.clientCompanyName.charAt(0).toUpperCase() : '';
    const templateId = shipmentDetails?.company?.coaTemplate ?? '1';
    const portOfLoading = shipmentDetails.portOfLoading ?? "";
    const portOfDestination = shipmentDetails.portOfDestination ?? "";


    // JSX Structure
    return (
        <div>

            <CustomLoader open={loading} />
            <DetailsPageCard
                columns={columns}
                title="COA"
                buttonTitle="Create COA"
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={modal}  >
                <CreateCOA
                    fetchData={fetchData}
                    customerName={customerName}
                    addressTo={addressTo}
                    companyName={companyName}
                    phoneNumber={phoneNumber}
                    productsList={products}
                    newShippingId={newShippingId}
                    shipmentId={shipmentId}
                    shipmentOrgId={shipmentOrgId}
                    setMessage={setMessage}
                    invoiceList={invoiceList}
                    shippingMarkList={shippingMarkList}
                    fetchButtonList={fetchButtonList}
                    portOfLoading={portOfLoading}
                    portOfDestination={portOfDestination}
                    portMasters={portMasters}
                    handleClose={handleClose} />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdateCOA
                    fetchData={fetchData}
                    companyName={companyName}
                    phoneNumber={phoneNumber}
                    productsList={products}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    invoiceList={invoiceList}
                    shippingMarkList={shippingMarkList}
                    portMasters={portMasters}
                    coaId={selectedCOA}
                />
            </CustomModal>

            <CustomModal open={viewModal} handleClose={handleCloseView}>
                <COAView
                    fetchData={fetchData}
                    companyName={companyName}
                    phoneNumber={phoneNumber}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    coaId={selectedCOA}
                    templateId={templateId}
                    shipmentOrgId={shipmentOrgId}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
};

export default COA;
